module.exports = __webpack_public_path__ + "img/2_186.df3e5016.png";